import { ErrorDetails } from '@ianesthesie-kit/services';

export enum ErrorCode {
  TOKEN_EXPIRED = 'E1-11-3-1002',
  NO_PENDING_PATIENT = 'E1-1-4-1008',
  AUTH_HEADER_IS_MISSING = 'E1-11-3-1000',
  QUESTIONNAIRE_NOT_ASSIGNED = 'E1-5-4-1007',
  UPLOAD_ANSWER_FILE_MISMATCH = 'E1-5-2-1041',
  QUESTIONNAIRE_IS_COMPLETED = 'E1-5-2-1040',
  SURGICAL_EVENT_ALREADY_PAID = 'E1-14-1-1000',
  INVALID_PROMO_CODE = 'E1-14-2-1000',
  FAILED_TO_BOOK_APPOINTMENT = 'E1-13-1-1001',
  FAILED_TO_CHARGE_CARD = 'E1-14-1-1001',
  INCONSISTENT_CONSENT_ITEMS = 'E1-12-2-1009',
  USER_ALREADY_ACTIVATED = 'E1-1-2-1012',
  USERNAME_ALREADY_EXISTS = 'E1-1-2-1000',
  PASSWORD_RESET_ALREADY_REQUESTED = 'E1-1-3-1005',
  LOCAL_FACING_NAME_DUPLICATE = 'E1-12-2-1046',
  LOCAL_FACING_NAME_ON_TEMPLATE = 'E1-12-2-1047'
}

const knownCodes: Set<string> = new Set(Object.values(ErrorCode));

export const isKnownErrorCode = (err: string | ErrorDetails): boolean => {
  if (!err) {
    return false;
  }
  const businessCode = typeof err === 'string' ? err : err.businessCode;
  return knownCodes.has(businessCode);
};
